import {stateClasses} from "./statesAndIdentifiers.js";
export const previousAttemptStepTemplate = ({
  stateClass = stateClasses.PREVIOUS_SUCCESS,
  title,
  step,
  dateTime,
}) => `
    <div class="step ${stateClass}">
        <div class="count-circle">
            <a
                href="#"
                title=${title}
            >
            </a>
        </div>
        <div class="info">
            <p class="title">${step}</p>
            <p class="date-text">${dateTime}</p>
        </div>
    </div>
`;

export const currentAttemptStepTemplate = ({
  stateClass = stateClasses.UNATTEMPTED,
  title,
  step,
  dateTime,
  id,
}) => `
    <div
      class="step ${stateClass}"
      id=${id}
    >
        <div class="count-circle">
            <a href="#" title=${title}></a>
        </div>
        <div class="info">
            <p class="title">${step}</p>
            <p class="date-text">${dateTime}</p>
        </div>
    </div>
`;

export const setPageTemplate = (src) => `
   <iframe src= "${src}" class ="overlay-iframe"> </iframe>
`;

export const comingSoonPageTemplate = (orderId, isReverseOrder) => `

<div class="wrapper mobile-wrapper">

<h2 class="heading" aria-label="Track your Order">Track your Order</h2>

<div class="order-blank">
    <div class="blank-img">
        <img src="picked-up.8990ed77.svg" alt="Order will be picked soon">
    </div>
    <div class="content-blank">
        <div class="orderid-text">Order ID #${orderId}</div>
        <h3>Your ${
          isReverseOrder ? "return" : ""
        } order will be picked up soon</h3>
    </div>
</div>

</div>
`;

export const onlyMap = () =>
  `<div class="track-map only-map" aria-label="Google map" id="map-container">`;

export const notFoundTemplate = (orgName) => `
<div class="wrapper mobile-wrapper">
<h2 class="heading" aria-label="Track your Order">Track your Order</h2>

<div class="order-blank">
    <div class="blank-img">
        <img src="not-found.57e1feca.svg" alt="order not found" role="img">
    </div>
    <div class="content-blank">
        <h3>Order not found</h3>
        <p>The order you are looking for could not be found. Please reach out to  <span id="org-name-span">${orgName}</span></p>
    </div>
</div>

</div>
`;

export const shipmentsModalTemplate = () => {
  return `
  <div class="shipments-modal-wrapper">
        <div class="shipments-modal-header">
          <span class="shipments-modal-heading shipments-text-config"></span>
          <span class="shipments-modal-heading-mweb shipments-text-config"></span>
          <img
            src="xmark-A3AAC2.62711b39.svg "
            class="shipments-modal-cross"
            height="16"
            width="16"
          />
        </div>
        <div class="shipments-modal-body">
          <div class="shipments-modal-search">
            <div class="shipments-modal-search-icon">
              <img src="magnifying-glass.64545ab0.svg" height="16" width="16" />
            </div>
            <input
              type="text"
              placeholder="Search by Shipment ID"
              class="shipments-modal-input"
            />
          </div>
          <div class="shipments-modal-no-results">
            <img src="magnifying-glass.64545ab0.svg" height="42" width="42" />
            <div>
              <div class="shipments-modal-no-results-title">
                No Results Found
              </div>
              <div class="shipments-modal-no-results-desc">
                Try altering your search
              </div>
            </div>
          </div>
          <div class="shipments-modal-list-wrapper">
            <div class="shipments-modal-list-header shipments-text-config">SHIPMENT ID</div>
            <div class="shipments-modal-list"></div>
          </div>
          <div class="shipments-modal-list-wrapper-mweb">
            <div class="shipments-modal-list-header-mweb shipments-text-config"></div>
            <div class="shipments-modal-list-mweb"></div>
          </div>
        </div>
        <div class="shipments-modal-footer">
          <span class="shipments-modal-previous">
            <img
              src="arrow-left-3D445C.a98607c1.svg"
              class="shipments-modal-previous-icon"
              height="16"
              width="16"
            />
            <img
              src="arrow-left-E0E3EB.12e705b4.svg"
              class="shipments-modal-previous-icon-disabled"
              height="16"
              width="16"
            />
            <span class="shipments-modal-previous-text">Previous</span>
          </span>
          <span class="shipments-modal-next">
            <span class="shipments-modal-next-text">Next</span>
            <img
              src="arrow-right-3D445C.840a00ff.svg"
              class="shipments-modal-next-icon"
              height="16"
              width="16"
            />
            <img
              src="arrow-right-E0E3EB.9ec5248b.svg"
              class="shipments-modal-next-icon-disabled"
              height="16"
              width="16"
            />
          </span>
        </div>
      </div>
    `;
};
